import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-review',
  templateUrl: './itinerary-review.component.html',
  styleUrls: ['./itinerary-review.component.css']
})
export class ItineraryReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
